import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  filterComponent: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    paddingTop: theme.spacing(1),
    '& .MuiAutocomplete-inputRoot': {
      height: 'fit-content',
    },
  },
  applyButton: {
    width: '120px',
  },
}));

export default useStyles;
